export const EMAIL_ADDRESS_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMAIL_ADDRESS_MAX_LENGTH = 254;

export const isEmailAddressValid = (email: string): boolean => {
    const normalized = `${email ?? ""}`.trim();
    return normalized.length > 0
        && normalized.length <= EMAIL_ADDRESS_MAX_LENGTH
        && EMAIL_ADDRESS_PATTERN.test(normalized);
};
